import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import App from './q2';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter as Router } from 'react-router-dom';
import { Provider as ReduxProvider } from 'react-redux';
import createStore from './store/store'; //Custom Store wih WeatherReducer with middleware rootSaga
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';

const store = createStore();

ReactDOM.render(
    <ReduxProvider store={store}>
        <Router>
            <App />
        </Router>
    </ReduxProvider>,
    document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
